export const Transition = ({index}) => {
  return (
    <div className={"section-transition " + "section-transition-" + index} />
  )
}
